import { DatePickerOnboardingForm } from "../DatePickerOnboardingForm";

interface IProps {
  value: string;
  placeholder: string;
  question: any;
  isDisableFutureDates?: boolean;
  onChange: (e: any) => void;
}

export const DatePickerInput = ({ value, placeholder, question, isDisableFutureDates, onChange }: IProps) => {
  return (
    <div className="onb-form-datepicker-input-wrapper">
      <DatePickerOnboardingForm
        setDateSelection={onChange}
        defaultSelected={value}
        placeholder={placeholder}
        inputFormat={"MM/DD/YYYY"}
        resetOnCancel={() => onChange("")}
        question={question}
        isDisableFutureDates={isDisableFutureDates}
      />
    </div>
  );
};
